import { render, staticRenderFns } from "./formWraplnd.vue?vue&type=template&id=71a8f78a&scoped=true"
import script from "./formWraplnd.vue?vue&type=script&lang=js"
export * from "./formWraplnd.vue?vue&type=script&lang=js"
import style0 from "./formWraplnd.vue?vue&type=style&index=0&id=71a8f78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8f78a",
  null
  
)

export default component.exports